module.exports = __webpack_public_path__ + "static/media/ResJ2.95704d0c.pdf";